import { useEffect, useState } from "react";
import { useParams } from "react-router";
import ResponsiveTable, { Column } from "@/components/Usados/ResponsiveTable";
import ActionMenu from "@/components/Usados/ActionMenu";
import { Modal } from "@/components/Usados/modal";
import Badge from "@/components/ui/badge/Badge";
import Button from "@/components/ui/button/Button";
import { Pencil, Trash } from "lucide-react";
import { apiFetch } from "@/service/api";

export default function ListarActividadTab({ onEdit }: any) {
  const { id: proyecto_id } = useParams();
  const [actividades, setActividades] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState<number | null>(null);

  const fetchData = async () => {
    const res = await apiFetch(
      `actividades-proyectos/find-all-proyecto/${proyecto_id}`,
    );
    if (res.ok) setActividades(await res.json());
    setLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, [proyecto_id]);

  const confirmDelete = async () => {
    if (!idToDelete) return;
    await apiFetch(`actividades-proyectos/remove/${idToDelete}`, {
      method: "DELETE",
    });
    setActividades(actividades.filter((a) => a.id !== idToDelete));
    setIsModalOpen(false);
  };

  const columns: Column<any>[] = [
    { label: "Nombre", key: "nombre" },
    {
      label: "Costo",
      key: "costo",
      render: (v: any) => `$ ${Number(v || 0).toLocaleString()}`,
    },
    {
      label: "Progreso",
      key: "progreso",
      render: (v: any) => (
        <div className="w-24">
          <div className="flex justify-between text-">
            <span>{v || 0}%</span>
          </div>
          <div className="w-full bg-gray-200 h-1.5 rounded-full">
            <div
              className="bg-green-500 h-1.5 rounded-full"
              style={{ width: `${v || 0}%` }}
            ></div>
          </div>
        </div>
      ),
    },
    {
      label: "Estado",
      key: "estado_actividad",
      render: (v: any) => (
        <Badge color={v === 3 ? "success" : v === 2 ? "warning" : "light"}>
          {v === 1 ? "Pendiente" : v === 2 ? "En Progreso" : "Completada"}
        </Badge>
      ),
    },
    {
      label: "Fechas",
      key: "fecha_inicio",
      render: (_: any, row: any) =>
        `${row.fecha_inicio?.split("T")[0]} → ${
          row.fecha_fin_estimada?.split("T")[0]
        }`,
    },
    {
      label: "Soporte",
      key: "soporte_url",
      render: (v: any) =>
        v ? (
          <a href={v} target="_blank" className="text-blue-600 text-xs">
            Ver
          </a>
        ) : (
          <span className="text-xs text-gray-400">-</span>
        ),
    },
    {
      label: "Acciones",
      key: "id",
      render: (_: any, row: any) => (
        <ActionMenu
          actions={[
            {
              label: "Editar",
              icon: <Pencil className="size-4" />,
              onClick: () => onEdit(row),
            },
            {
              label: "Eliminar",
              icon: <Trash className="size-4" />,
              onClick: () => {
                setIdToDelete(row.id);
                setIsModalOpen(true);
              },
            },
          ]}
        />
      ),
    },
  ];

  if (loading) return <div className="p-10 text-center">Cargando...</div>;

  return (
    <div>
      <ResponsiveTable columns={columns} data={actividades} />
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        className="max-w-md"
      >
        <div className="p-6">
          <h4 className="font-semibold mb-4">¿Eliminar actividad?</h4>
          <p className="text-sm text-gray-500 mb-6">
            Se eliminarán también sus puntos y avances ligados.
          </p>
          <div className="flex gap-3 justify-end">
            <Button variant="outline" onClick={() => setIsModalOpen(false)}>
              Cancelar
            </Button>
            <Button
              onClick={confirmDelete}
              className="bg-red-600 hover:bg-red-700"
            >
              Eliminar
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
